import React, { useMemo, useState } from "react";
import { Sparkles, CheckCircle2, XCircle, SkipForward, Flame } from "lucide-react";
import { SKILL_CATEGORIES, SKILL_ITEMS } from "@/data/skillQuiz";

const rand = (n, not) => {
  if (n <= 1) return 0;
  let r;
  do { r = Math.floor(Math.random() * n); } while (r === not);
  return r;
};

export default function SkillQuiz({ stats, setStats }) {
  const [idx, setIdx] = useState(() => rand(SKILL_ITEMS.length));
  const [picked, setPicked] = useState(null);
  const [streak, setStreak] = useState(0);
  const item = SKILL_ITEMS[idx];
  const ok = picked && item[1].includes(picked);
  const acc = useMemo(() => (stats.total ? Math.round((stats.correct / stats.total) * 100) : 0), [stats]);

  const pick = (k) => {
    if (picked) return;
    setPicked(k);
    const good = item[1].includes(k);
    setStreak((s) => (good ? s + 1 : 0));
    setStats({ total: stats.total + 1, correct: stats.correct + (good ? 1 : 0), best: Math.max(stats.best || 0, good ? streak + 1 : 0) });
  };
  const next = () => { setIdx(rand(SKILL_ITEMS.length, idx)); setPicked(null); };

  return (
    <div>
      <div className="section-head">
        <span className="eyebrow">KİMÖ-405 · Etkileşimli Araç</span>
        <h1 className="page-title">Beceri ve Eğilim Sınıflandırma Mini Testi</h1>
        <p className="page-sub">Verilen kavram KB1, KB2, KB3, Fen Bilimleri Alan Becerisi ya da E1/E2/E3 eğilimlerinden hangisidir? Hızlı pratik yap.</p>
      </div>

      <div className="sq-stats">
        <div className="stat"><span className="stat-n">{stats.correct}/{stats.total}</span><span>Doğru</span></div>
        <div className="stat"><span className="stat-n">%{acc}</span><span>Başarı</span></div>
        <div className="stat"><span className="stat-n warn"><Flame size={16} /> {streak}</span><span>Seri</span></div>
        <div className="stat"><span className="stat-n muted">{stats.best || 0}</span><span>En iyi seri</span></div>
        <button className="btn btn-ghost" onClick={() => setStats({ total: 0, correct: 0, best: 0 })} data-testid="sq-reset">Sıfırla</button>
      </div>

      <div className="sq-card" data-testid="sq-card">
        <span className="eyebrow"><Sparkles size={13} /> Bu kavram hangisi?</span>
        <div className="sq-term" data-testid="sq-term">{item[0]}</div>
        <div className="sq-options">
          {SKILL_CATEGORIES.map((c) => {
            let cls = "sq-opt";
            if (picked) {
              if (item[1].includes(c.key)) cls += " opt-correct";
              else if (picked === c.key) cls += " opt-wrong";
              else cls += " opt-dim";
            }
            return (
              <button key={c.key} className={cls} onClick={() => pick(c.key)} disabled={!!picked} data-testid={`sq-opt-${c.key}`}>
                {c.label}
              </button>
            );
          })}
        </div>
        {picked && (
          <div className={`feedback ${ok ? "fb-ok" : "fb-bad"}`} data-testid="sq-feedback">
            <div className="fb-title">{ok ? <><CheckCircle2 size={17} /> Doğru!</> : <><XCircle size={17} /> Yanlış — doğru: {item[1].map((k) => SKILL_CATEGORIES.find((c) => c.key === k).label).join(" / ")}</>}</div>
            <div className="fb-how">{item[2]}</div>
          </div>
        )}
        <div className="sq-actions">
          <button className="btn btn-accent" onClick={next} data-testid="sq-next">
            {picked ? "Sonraki kavram" : <><SkipForward size={15} /> Geç</>}
          </button>
        </div>
      </div>
    </div>
  );
}
